/* NanoTech — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---------- Reveal + texto palabra a palabra ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('nt-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function splitWords(el) {
    if (el.dataset.ntSplitDone) return;
    el.dataset.ntSplitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'nt-w';
            var inner = document.createElement('span'); inner.textContent = part;
            inner.style.setProperty('--nt-i', i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') { walk(child); }
      });
    })(el);
  }

  function initReveal(root) {
    root.querySelectorAll('.nt-split').forEach(splitWords);
    root.querySelectorAll('.nt-reveal, .nt-curtain, .nt-split, [data-nt-count]').forEach(function (el) {
      if (!io || reduce) { el.classList.add('nt-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCount(root) {
    root.querySelectorAll('[data-nt-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-nt-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      var done = false;
      if (!reduce && io) el.textContent = (0).toFixed(dec);
      function run() {
        if (done) return; done = true;
        if (reduce) { el.textContent = target.toFixed(dec); return; }
        var t0 = null, dur = 1800;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (!io) return run();
      new IntersectionObserver(function (en, obs) {
        if (en[0].isIntersecting) { run(); obs.disconnect(); }
      }, { threshold: 0.4 }).observe(el);
    });
  }

  /* ---------- Brillo que sigue al cursor + inclinación 3D ---------- */
  function initPointer(root) {
    if (!fine || reduce) return;
    root.querySelectorAll('.nt-glow').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--gx', (e.clientX - r.left) + 'px');
        el.style.setProperty('--gy', (e.clientY - r.top) + 'px');
      });
    });
    root.querySelectorAll('[data-nt-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-nt-tilt')) || 6;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg) translateZ(0)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    root.querySelectorAll('[data-nt-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * 0.18) + 'px');
        el.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * 0.25) + 'px');
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--mx', '0px'); el.style.setProperty('--my', '0px'); });
    });
    root.querySelectorAll('[data-nt-pointer]').forEach(function (wrap) {
      var target = wrap.querySelector('[data-nt-pointer-target]');
      var k = parseFloat(wrap.getAttribute('data-nt-pointer')) || 14;
      if (!target) return;
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        target.style.setProperty('--px', (-x * k) + 'px');
        target.style.setProperty('--py', (-y * k) + 'px');
      });
    });
  }

  /* ---------- Parallax suave con el scroll ---------- */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-nt-parallax]').forEach(function (el) { parallaxEls.push(el); });
    tick();
  }
  var ticking = false;
  function tick() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        if (!el.isConnected) return;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-nt-parallax')) || 0.15;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--sy', (center * -k).toFixed(1) + 'px');
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);

  /* ---------- Escena fija (imagen sticky + pasos) ---------- */
  function initScene(root) {
    root.querySelectorAll('[data-nt-scene]').forEach(function (scene) {
      var steps = scene.querySelectorAll('[data-nt-step]');
      var frames = scene.querySelectorAll('[data-nt-frame]');
      var dots = scene.querySelectorAll('[data-nt-dot]');
      if (!steps.length) return;
      function activate(i) {
        frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) activate(parseInt(e.target.getAttribute('data-nt-step'), 10) || 0);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* ---------- Carrusel (flechas + arrastre) ---------- */
  function initCarousel(root) {
    root.querySelectorAll('[data-nt-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-nt-track]');
      if (!track) return;
      function stepSize() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : 300;
      }
      wrap.querySelectorAll('[data-nt-prev], [data-nt-next]').forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: (b.hasAttribute('data-nt-next') ? 1 : -1) * stepSize(), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      var bar = wrap.querySelector('[data-nt-progress]');
      function prog() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.max(0.08, track.scrollLeft / max) : 1) + ')';
      }
      track.addEventListener('scroll', prog, { passive: true }); prog();
      if (!fine) return;
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { down = false; track.classList.remove('is-dragging'); });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Acordeón con altura animada ---------- */
  function initAccordion(root) {
    root.querySelectorAll('.nt-acc details').forEach(function (d) {
      var sum = d.querySelector('summary'), body = d.querySelector('.nt-acc__body');
      if (!sum || !body || d.dataset.ntAcc) return;
      d.dataset.ntAcc = '1';
      sum.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          d.classList.remove('is-open');
          setTimeout(function () { d.open = false; body.style.height = ''; }, 450);
        } else {
          d.open = true; d.classList.add('is-open');
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = body.scrollHeight + 'px'; });
          setTimeout(function () { body.style.height = ''; }, 450);
        }
      });
    });
  }

  /* ---------- Página de producto: galería, variantes, cantidad, barra fija ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }
  function initProduct(root) {
    root.querySelectorAll('[data-nt-product]').forEach(function (p) {
      var main = p.querySelectorAll('[data-nt-slide]');
      var thumbs = p.querySelectorAll('[data-nt-thumb]');
      function show(i) {
        main.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var stage = p.querySelector('[data-nt-stage]');
      if (stage && fine && !reduce) {
        stage.addEventListener('pointermove', function (e) {
          var a = stage.querySelector('.is-active img'); if (!a) return;
          var r = stage.getBoundingClientRect();
          a.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          a.style.transform = 'scale(1.6)';
        });
        stage.addEventListener('pointerleave', function () { var a = stage.querySelector('.is-active img'); if (a) a.style.transform = ''; });
      }

      var dataEl = p.querySelector('[data-nt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = p.getAttribute('data-nt-money');
      var idInput = p.querySelector('input[name="id"]');
      var priceEl = p.querySelector('[data-nt-price]');
      var compareEl = p.querySelector('[data-nt-compare]');
      var btns = p.querySelectorAll('[data-nt-add]');
      var labelAdd = p.getAttribute('data-nt-label-add'), labelOut = p.getAttribute('data-nt-label-out');
      function current() {
        var sel = [];
        p.querySelectorAll('[data-nt-option]').forEach(function (g) {
          var c = g.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }
      function update() {
        var v = current();
        p.querySelectorAll('[data-nt-option]').forEach(function (g) {
          var c = g.querySelector('input:checked'), out = g.querySelector('[data-nt-option-value]');
          if (c && out) out.textContent = c.value;
        });
        btns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var l = b.querySelector('[data-nt-add-label]');
          if (l) l.textContent = v && v.available ? labelAdd : labelOut;
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        p.querySelectorAll('[data-nt-price-mini]').forEach(function (m) { m.textContent = money(v.price, fmt); });
        if (compareEl) {
          var on = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.textContent = on ? money(v.compare_at_price, fmt) : '';
          compareEl.hidden = !on;
        }
        if (v.featured_media_index != null && v.featured_media_index > -1) show(v.featured_media_index);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u);
        }
      }
      p.querySelectorAll('[data-nt-option] input').forEach(function (i) { i.addEventListener('change', update); });
      if (variants.length) update();

      var qty = p.querySelector('[data-nt-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            input.value = Math.max(1, n + (b.hasAttribute('data-nt-plus') ? 1 : -1));
          });
        });
      }

      var bar = p.querySelector('[data-nt-sticky]'), form = p.querySelector('[data-nt-form]');
      if (bar && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(form);
        var stickyBtn = bar.querySelector('[data-nt-sticky-add]');
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          var b = form.querySelector('[data-nt-add]'); if (b) b.click();
        });
      }
    });
  }

  /* ---------- Añadir al carrito sin salir de la página (usa el cajón de Dawn) ---------- */
  function initAjaxCart(root) {
    root.querySelectorAll('form[data-nt-ajax]').forEach(function (form) {
      if (form.dataset.ntAjaxDone) return;
      form.dataset.ntAjaxDone = '1';
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
        var fd = new FormData(form);
        if (drawer) {
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (res.status) { alert(res.description || res.message || 'No se pudo añadir'); return; }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
          if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1400); }
        }).catch(function () { form.submit(); });
      });
    });
  }

  /* ---------- Índice de categorías: foto que sigue al cursor ---------- */
  function initIndex(root) {
    if (!fine) return;
    root.querySelectorAll('[data-nt-index]').forEach(function (sec) {
      var prev = sec.querySelector('[data-nt-index-preview]');
      if (!prev) return;
      var imgs = prev.querySelectorAll('img');
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      function loop() {
        cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
        prev.style.setProperty('--px', cx.toFixed(1) + 'px');
        prev.style.setProperty('--py', cy.toFixed(1) + 'px');
        raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.5 ? requestAnimationFrame(loop) : null;
      }
      sec.querySelectorAll('[data-nt-index-row]').forEach(function (row) {
        var i = parseInt(row.getAttribute('data-nt-index-row'), 10);
        row.addEventListener('pointerenter', function () {
          imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
          prev.classList.add('is-on');
        });
        row.addEventListener('pointermove', function (e) {
          var w = prev.offsetWidth, h = prev.offsetHeight;
          tx = Math.min(Math.max(e.clientX + 40, window.innerWidth * 0.58), window.innerWidth - w - 16);
          ty = Math.max(16, Math.min(e.clientY - h / 2, window.innerHeight - h - 16));
          if (!raf) raf = requestAnimationFrame(loop);
        });
      });
      var list = sec.querySelector('.nt-idx__list');
      if (list) list.addEventListener('pointerleave', function () { prev.classList.remove('is-on'); });
    });
  }

  /* ---------- Arranque (y re-arranque dentro del editor de Shopify) ---------- */
  function init(root) {
    root = root || document;
    initReveal(root); initCount(root); initPointer(root); initParallax(root);
    initScene(root); initCarousel(root); initAccordion(root); initProduct(root); initAjaxCart(root); initIndex(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
